import { useEffect, useState } from "react"

export default function RemountByInterval({ durationMinutes = 1, children, clearData, ...props }) {
   
    const [isMounted, setIsMounted] = useState(true)

    useEffect(() => {
        const interval = setInterval(() => {
            setIsMounted(false)
            clearData?.() // clear the uplifted lazy fetched data
            setTimeout(() => {
                setIsMounted(true)
            }, 10)
        }, durationMinutes * 60 * 1000);

        return () => {
            clearInterval(interval)
        }

    }, [])

    return isMounted ? children : null
}
